export default __webpack_public_path__ + "static/InfinityMaxCam_WIND_rotor_1-removebg-0af1c2128542d2ee2c203b5d03265193.jpg";